import React, {FC} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import {Link as RouterLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {QrCode} from "@mui/icons-material";
import {IWinnerTicket, IWish} from "../../../../store/wish/Helper";
import {getWinnerAvatarSrc, getWinnerDisplayName, isWinnerTicketForUser} from "../../../../util/hooks/useWinnerHelpers";
import {getWishWinnerPath} from "../../../../util/routeHelpers";

interface Props {
    winner: IWinnerTicket;
    wish: Pick<IWish, "id" | "slug">;
    userEmail: string | undefined;
}

const WinnerRow: FC<Props> = ({winner, wish, userEmail}) => {
    const {t} = useTranslation();

    if (!winner?.ticket) return null;

    const ticket = winner.ticket;
    const displayName = getWinnerDisplayName(winner);
    const avatarSrc = getWinnerAvatarSrc(winner);
    const isUserWinner = isWinnerTicketForUser(winner, userEmail);
    const canClaimPrize = isUserWinner && !winner.redeemed_at;

    return (
        <TableRow key={ticket.id}>
            <TableCell>{ticket.code}</TableCell>
            <TableCell>
                <Grid container gap={1} alignItems="center">
                    <Avatar
                        sx={{width: 32, height: 32, mr: 0.5}}
                        src={avatarSrc}
                        alt={displayName}
                    />
                    {displayName}
                </Grid>
            </TableCell>
            <TableCell align="right">
                {canClaimPrize && (
                    <Button
                        variant="contained"
                        color="primary"
                        component={RouterLink}
                        startIcon={<QrCode/>}
                        to={getWishWinnerPath(wish)}
                    >
                        {t('claim_prize')}
                    </Button>
                )}
            </TableCell>
        </TableRow>
    );
};

export default WinnerRow;
